import { DocumentStatus } from 'src/app/modules/referrals/interfaces/referrals.model';
import { convertRadioToBoolean } from 'src/app/shared/functions/convert-radio-to-boolean';

export class IepSubmitEligibilityRequest {
        iepFormSK: string;
        disability: number;
        isLocked: boolean;
        isSubmit: boolean;
        lackOutstructReading: boolean;
        lackInstructMath: boolean;
        limitedEnglishProf: boolean;
        disabilityClass: any;
        otherImpairment: number;
        otherImpairementDesc: string;
        specialEdServ: boolean;
        medicalCondition: boolean;
        physicalLimit: boolean;
        learning: boolean;
        behavior: boolean;
        participation: boolean;
        reqMedicalCare: boolean;
        reqHealthCare: boolean;
        lastModuser: string;
        //lastModTs : Date
        iepType: string;
        iepMeetingType: string;
        referralSK: string;
        studentSK: string;
        iepMeetingDate: string;
        projectedAnnRevDate: Date;
        projectedNxtManThreeYrRevalDate: Date;
        iepAmendment: boolean;
        reconveneIEPMeeting: boolean;
        requiresSpecEd: any;
        meetsOtherDef: any;
        typeOfMeeting: number;
        actionType: any;
        isAnnual: boolean;
        referenceIEPFormsk: string;
        caseStage: number;
        reasonForDelayId: any;
        dob: string;
        dbn: string;
        isPreschool: boolean;
       
        constructor(eligibilityData: any) {
                this.iepFormSK = eligibilityData.iepFormSK;
                this.isLocked = eligibilityData.isLocked;
                this.isSubmit = eligibilityData.isSubmit;
                this.actionType = this.isSubmit ? DocumentStatus.Submit : DocumentStatus.SaveForLater
                this.disability = eligibilityData.disability?.id;
                this.lackOutstructReading = eligibilityData?.lackOutstructReading === 'Yes' ? true : eligibilityData?.lackOutstructReading === 'No' ? false : null;
                this.lackInstructMath = eligibilityData.lackInstructMath ?? false;
                this.limitedEnglishProf = eligibilityData.limitedEnglishProf ?? false;
                this.disabilityClass = eligibilityData.disabilityClass ? convertRadioToBoolean(eligibilityData.disabilityClass) : undefined;
                this.otherImpairment = eligibilityData.otherImpairment?.id
                this.requiresSpecEd = eligibilityData.requiresSpecEd ? convertRadioToBoolean(eligibilityData.requiresSpecEd) : undefined;
                this.otherImpairementDesc = eligibilityData.otherImpairementDesc;
                this.specialEdServ = eligibilityData.specialEdServ;
                this.medicalCondition = eligibilityData.medicalCondition;
                this.physicalLimit = eligibilityData.physicalLimit;
                this.learning = eligibilityData.learning;
                this.behavior = eligibilityData.behavior;
                this.participation = eligibilityData.participation;
                this.reqMedicalCare = eligibilityData.reqMedicalCare;
                this.reqHealthCare = eligibilityData.reqHealthCare;
                this.lastModuser = eligibilityData.lastModuser;
                this.iepType = eligibilityData.iepType?.id;
                this.iepMeetingType = eligibilityData.iepMeetingType?.id;
                //required
                this.referralSK = eligibilityData.referralSK;
                this.dob = eligibilityData?.dob;
                this.dbn = eligibilityData?.dbn;
                //optional
                this.iepMeetingDate = eligibilityData.iepMeetingDate;
                this.projectedAnnRevDate = eligibilityData.projectedAnnRevDate;
                this.projectedNxtManThreeYrRevalDate = eligibilityData.projectedNxtManThreeYrRevalDate;
                this.iepAmendment = eligibilityData.iepAmendment;
                this.reconveneIEPMeeting = eligibilityData.reconveneIEPMeeting;
                this.meetsOtherDef = eligibilityData.meetsOtherDef !== undefined ? convertRadioToBoolean(eligibilityData.meetsOtherDef) : eligibilityData.meetsOtherDef;
                this.typeOfMeeting = eligibilityData?.iepMeetingType?.id;
                this.isAnnual = eligibilityData?.isAnnual;
                this.referenceIEPFormsk = eligibilityData?.referenceIEPFormsk;
                this.studentSK = eligibilityData?.studentSK;
                this.reasonForDelayId = eligibilityData?.reasonForDelayId;
        }

        get id(): string {
                return this.iepFormSK
        }


}